// Guards for resource library site page items

import {
    ResourceLibrarySitePagePlainTextImageSection,
    ResourceLibrarySitePageRichTextImageSection,
    ResourceLibrarySitePageSectionBlock,
    ResourceLibrarySitePageTextImageSection,
} from '../types/resourceLibrarySitePageItems';

export function isSitePagePlainTextImageSection(
    section: ResourceLibrarySitePageSectionBlock
): section is ResourceLibrarySitePagePlainTextImageSection {
    return section.kind === 'plainTextImageSection';
}

export function isSitePageRichTextImageSection(
    section: ResourceLibrarySitePageSectionBlock
): section is ResourceLibrarySitePageRichTextImageSection {
    return section.kind === 'richTextImageSection';
}

export function isSitePageTextImageSection(
    section: ResourceLibrarySitePageSectionBlock
): section is ResourceLibrarySitePageTextImageSection {
    return isSitePagePlainTextImageSection(section) || isSitePageRichTextImageSection(section);
}
